"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _CompanyRecord = _interopRequireDefault(require("customer-data-objects/company/CompanyRecord"));

var _react = require("react");

var CompanyType = _react.PropTypes.instanceOf(_CompanyRecord.default);

var _default = CompanyType;
exports.default = _default;
module.exports = exports.default;